import { Component, inject, computed, signal, effect } from '@angular/core';
import { AppVersionService } from '../../services/app-version.service';

// PAT-203 — dismissible pre-maintenance announcement banner (SSE countdown).
@Component({
  selector: 'app-maintenance-banner',
  standalone: true,
  imports: [],
  templateUrl: './maintenance-banner.component.html',
  styleUrl: './maintenance-banner.component.scss',
})
export class MaintenanceBannerComponent {
  readonly versionSvc = inject(AppVersionService);

  readonly announcement = this.versionSvc.maintenanceAnnouncement;
  readonly secondsLeft = this.versionSvc.maintenanceSecondsLeft;
  readonly dismissed = signal<boolean>(false);

  readonly countdownDisplay = computed(() => {
    const s = this.secondsLeft();
    if (s === null) return null;
    if (s <= 0) return 'Starting now…';
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m}:${String(sec).padStart(2, '0')}`;
  });

  constructor() {
    // Reset dismissed whenever a fresh announcement arrives so the card always shows first
    effect(() => {
      if (this.announcement() !== null) {
        this.dismissed.set(false);
      }
    });
  }

  dismiss(): void {
    this.dismissed.set(true);
  }
}
